
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isEmpty, ofArray, exists as exists_1, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { exists } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { ConsumableTable, SetTable, ToolWithQuantityTable, ToolTable, entityImageColumns } from "../../Widgets/Notification/AssignmentEntityTables.js";
import { Msg } from "./Types.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SignatureDialog } from "../../Components/SignatureDialog.js";
import { FormState__getValidation, FormState_get_empty } from "../../Shared/Shared.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Variant as Variant_3 } from "../../Variant.js";
import { ErrorAlert, InformationAlert } from "../../Components/Alert.js";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { TableContainer } from "../../Widgets/Container.js";
import { EntityType } from "../../Shared/AssignmentNotification.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TextValue } from "../../Components/Text.js";
import { Button, TextButton } from "../../Components/Button.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import Check from "../../../public/assets/icons/Check.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function DetailView(props) {
    let elems_11, elems_10;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsSignatureDialogOpen = patternInput_1[1];
    let notificationImages;
    const matchValue = props.Detail;
    notificationImages = ((matchValue.tag === 0) ? empty() : matchValue.fields[0].Images);
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const receiverActionState = exists((_arg, files) => exists_1((file) => {
        if (file.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, files), props.SelectedReceiverFilesByEntity) ? "disabled" : componentState;
    const imageColumns = (getId, entityType) => entityImageColumns(getId, entityType, notificationImages, props.SelectedReceiverFilesByEntity, true, componentState, t, (tupledArg) => {
        props.Dispatch(new Msg(6, [tupledArg[0], tupledArg[1], tupledArg[2]]));
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "rounded", "px-12", "py-9", "bg-background", "min-h-full", "items-center"])], (elems_11 = [createElement(SignatureDialog, {
        Classes: empty(),
        Description: "",
        FormState: FormState_get_empty(),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsSignatureDialogOpen(false);
        },
        OnConfirm: (file_1) => {
            props.Dispatch(new Msg(10, [file_1]));
            setIsSignatureDialogOpen(false);
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[90%] lg:min-w-[80rem]", "flex", "flex-col"])], (elems_10 = toList(delay(() => {
        let elems_2, elems, elems_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "gap-5", "bg-white", "rounded", "px-12", "py-9"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center"])], (elems = [reactElement("img", {
            className: join(" ", ["w-80"]),
            src: (Variant_3.tag === 0) ? "assets/images/mwk_logo.png" : "assets/images/inventory-one-logo.png",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(InformationAlert, {
            Label: "notification.email_assignment_user_info",
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems_1 = [createElement(PropertyList, {
            Properties: toList(delay(() => append(singleton({
                Label: t("general.sender"),
                TestId: "email-notification-sender-name-test-id",
                Value: props.AssignEmailNotificationDetailDto.SenderName,
            }), delay(() => append(singleton({
                Label: t("general.receiver"),
                TestId: "email-notification-receiver-name-test-id",
                Value: props.AssignEmailNotificationDetailDto.ReceiverName,
            }), delay(() => {
                let matchValue_1, returnDate;
                return append((matchValue_1 = props.AssignEmailNotificationDetailDto.OptionalReturnDate, (matchValue_1 == null) ? (empty_1()) : ((returnDate = matchValue_1, singleton({
                    Label: t("tool.planned_return_date"),
                    TestId: "email-notification-planned-return-date-test-id",
                    Value: toString(toLocalTime(returnDate), "dd.MM.yyyy"),
                })))), delay(() => singleton({
                    Label: t("general.comment"),
                    TestId: "email-notification-comment-test-id",
                    Value: props.AssignEmailNotificationDetailDto.Comment,
                })));
            })))))),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let Title_1;
            return append(!isEmpty(props.AssignEmailNotificationDetailDto.Tools) ? singleton(createElement(TableContainer, (Title_1 = t("general.tool"), {
                Content: createElement(ToolTable, {
                    ExtraColumns: imageColumns((row) => row.Id, new EntityType(0, [])),
                    Tools: props.AssignEmailNotificationDetailDto.Tools,
                }),
                Title: unwrap(Title_1),
            }))) : empty_1(), delay(() => {
                let Title_2;
                return append(!isEmpty(props.AssignEmailNotificationDetailDto.ToolsWithQuantity) ? singleton(createElement(TableContainer, (Title_2 = t("general.tool_with_quantity"), {
                    Content: createElement(ToolWithQuantityTable, {
                        ExtraColumns: imageColumns((row_1) => row_1.Id, new EntityType(1, [])),
                        ToolsWithQuantity: props.AssignEmailNotificationDetailDto.ToolsWithQuantity,
                    }),
                    Title: unwrap(Title_2),
                }))) : empty_1(), delay(() => {
                    let Title_3;
                    return append(!isEmpty(props.AssignEmailNotificationDetailDto.Sets) ? singleton(createElement(TableContainer, (Title_3 = t("general.set"), {
                        Content: createElement(SetTable, {
                            ExtraColumns: imageColumns((row_2) => row_2.Id, new EntityType(2, [])),
                            Sets: props.AssignEmailNotificationDetailDto.Sets,
                        }),
                        Title: unwrap(Title_3),
                    }))) : empty_1(), delay(() => {
                        let Title_4;
                        return append(!isEmpty(props.AssignEmailNotificationDetailDto.Consumables) ? singleton(createElement(TableContainer, (Title_4 = t("general.consumable"), {
                            Content: createElement(ConsumableTable, {
                                Consumables: props.AssignEmailNotificationDetailDto.Consumables,
                                ExtraColumns: imageColumns((row_3) => row_3.Id, new EntityType(3, [])),
                            }),
                            Title: unwrap(Title_4),
                        }))) : empty_1(), delay(() => {
                            let elems_9, elems_6, elems_8, elems_7, Label_5, Label_6;
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "sm:flex-row", "gap-3", "justify-between", "mt-8", "bg-white", "rounded", "px-5", "sm:px-12", "py-9"])], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_6 = toList(delay(() => {
                                let matchValue_2, elems_4, signature, imageUrl, elems_3;
                                return props.AssignEmailNotificationDetailDto.WithSignature ? append((matchValue_2 = props.Signature, (matchValue_2 == null) ? append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_4 = [createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "",
                                    Text: t("notification.signature_description"),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => singleton(createElement(TextButton, {
                                    ComponentState: componentState,
                                    Label: t("notification.sign"),
                                    OnClick: () => {
                                        setIsSignatureDialogOpen(true);
                                    },
                                    TestId: "notification-sign-button-test-id",
                                    Variant: "blueButton",
                                })))) : ((signature = matchValue_2, (imageUrl = URL.createObjectURL(signature), singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_3 = [createElement(TextValue, {
                                    FontWeight: "bold",
                                    TestId: "",
                                    Text: t("general.signature"),
                                }), reactElement("img", {
                                    className: join(" ", ["h-24"]),
                                    src: imageUrl,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))))))), delay(() => {
                                    let elems_5;
                                    const matchValue_3 = FormState__getValidation(props.FormState, t, "signature");
                                    if (matchValue_3 == null) {
                                        return empty_1();
                                    }
                                    else {
                                        const validationMessage = matchValue_3;
                                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]", "mb-5"])], (elems_5 = [createElement(ErrorAlert, {
                                            Label: validationMessage,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                                    }
                                })) : empty_1();
                            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2", "sm:gap-5", "place-items-center"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_7 = [createElement(Button, (Label_5 = t("notification.reject"), {
                                ComponentState: receiverActionState,
                                Icon: Delete_1(),
                                Label: Label_5,
                                OnClick: () => {
                                    props.Dispatch(new Msg(1, []));
                                },
                                TestId: "notification-reject-button",
                                Variant: "redButton",
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement(Button, (Label_6 = t("notification.accept"), {
                                ComponentState: (props.AssignEmailNotificationDetailDto.WithSignature && (props.Signature == null)) ? "disabled" : receiverActionState,
                                Icon: Check(),
                                Label: Label_6,
                                OnClick: () => {
                                    if (props.AssignEmailNotificationDetailDto.WithSignature && (props.Signature != null)) {
                                        props.Dispatch(new Msg(11, []));
                                    }
                                    else {
                                        props.Dispatch(new Msg(0, []));
                                    }
                                },
                                TestId: "notification-assign-button",
                                Variant: "primary",
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
}

export function AcceptEmailNotificationView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.NotificationId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.AcceptEmailNotificationDetail;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(DetailView, {
            AssignEmailNotificationDetailDto: matchValue.fields[0],
            Detail: state_1.Detail,
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
            SelectedReceiverFilesByEntity: state_1.SelectedReceiverFilesByEntity,
            Signature: unwrap(state_1.Signature),
        });
    }
}

